var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.6667 3.27471C23.6554 3.46337 24.2415 3.67073 24.7479 4.29452C25.3823 5.07572 25.3487 5.92005 25.2816 7.60871C25.0407 13.6794 23.6802 21.3334 16.0003 21.3334C8.3203 21.3334 6.95979 13.6794 6.71878 7.60871C6.65174 5.92005 6.61822 5.07572 7.25251 4.29452C7.88679 3.51333 8.64595 3.38524 10.1643 3.12907C11.663 2.8762 13.6222 2.66675 16.0003 2.66675C16.9579 2.66675 17.8476 2.70072 18.6667 2.7578",
    stroke: "#DFDCED",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.3333 6.66675L26.5981 7.08836C27.9182 7.52839 28.5782 7.7484 28.9557 8.27219C29.3333 8.79597 29.3333 9.49172 29.3332 10.8832V10.9799C29.3332 12.1276 29.3332 12.7014 29.0569 13.1709C28.7806 13.6403 28.279 13.919 27.2758 14.4763L23.3333 16.6667",
    stroke: "#DFDCED",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.66661 6.66675L5.40178 7.08836C4.0817 7.52839 3.42166 7.7484 3.04415 8.27219C2.66663 8.79597 2.66665 9.49172 2.66669 10.8832V10.9799C2.66673 12.1276 2.66674 12.7014 2.94299 13.1709C3.21923 13.6403 3.72086 13.919 4.72409 14.4763L8.66661 16.6667",
    stroke: "#DFDCED",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16 22.6667V25.3334",
    stroke: "#DFDCED",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.6666 29.3333H11.3333L11.7856 27.0719C11.9103 26.4487 12.4575 26 13.093 26H18.9069C19.5425 26 20.0897 26.4487 20.2144 27.0719L20.6666 29.3333Z",
    stroke: "#DFDCED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M24 29.3333H8",
    stroke: "#DFDCED",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupIcon);
export default __webpack_public_path__ + "static/media/cupIcon.ad263a18206de69a6d7f56245fe7b8b4.svg";
export { ForwardRef as ReactComponent };